import { observer } from 'mobx-react';
import React from 'react';

import type Asset from 'stores/Asset';

import DrawerButton from '../DrawerButton';

export interface UpdateFileButtonProps {
  asset: Asset;
}

function UpdateFileButton({ asset }: UpdateFileButtonProps) {
  const showUploadAssetModal = () => {
    const uploadManager = asset.parent?.uploadManager;
    if (!uploadManager) return;
    uploadManager.beginUpdate(asset.data.name);
    uploadManager.modalVisible = true;
  };

  return (
    <DrawerButton disabled={asset.loading} onClick={showUploadAssetModal}>
      Update
    </DrawerButton>
  );
}

export default observer(UpdateFileButton);
